"use strict";
$(function ($) {
/*-------------------------
ハンバーガーメニュー
-------------------------*/
    $('#js-hamburger').on('click', function () {
        if ($('#js-hamburger').hasClass('is-openSP')) {
            $('#js-drawer-menu, #js-hamburger').removeClass('is-openSP');
            $('body').css('overflow', ''); // スクロールを再度有効にする
            $('#js-hamburger').attr('aria-expanded', 'false');
        } else {
            $('#js-drawer-menu, #js-hamburger').addClass('is-openSP');
            $('body').css('overflow', 'hidden'); // スクロールを無効にする
            $('#js-hamburger').attr('aria-expanded', 'true');
        }
    });

    // ハンバーガーメニュー内をクリックしたらハンバーガーメニューを閉じる
    $('#js-drawer-menu a[href]').on('click', function() {
        $('#js-hamburger').trigger('click');
    });


/*-------------------------
スクロールでヘッダーの背景色変更
-------------------------*/
    $(window).on('scroll', function() {
            const $header = $('.header');
            const isScrolled = $(this).scrollTop() >= 100;

            $header.toggleClass('header__sticky', isScrolled);
            $('body').css('marginTop', isScrolled ? $header.outerHeight() : 0);
        });

    /*-------------------------
    フローティングバナー
    -------------------------*/
    const floating = $('#js-floating');
    floating.hide();

    $(window).on('scroll', function() {
        if ($(this).scrollTop() > 70) {
            floating.fadeIn();
        } else {
            floating.fadeOut();
        }
    });
/*-------------------------
タブ切り替え
-------------------------*/

    var $tabs   = $('.policy-tablist [role="tab"]');
    var $panels = $('.policy-panels [role="tabpanel"]');

    function activateTab($tab, focus) {
        var panelId = $tab.attr('aria-controls');

        // タブ状態更新
        $tabs.attr({'aria-selected':'false', 'tabindex':'-1'})
            .parent().removeClass('is-active');
        $tab.attr({'aria-selected':'true', 'tabindex':'0'})
            .parent().addClass('is-active');
        if (focus) $tab.focus();

        // パネル切替
        $panels.attr('hidden', true).removeClass('is-active');
        $('#' + panelId).removeAttr('hidden').addClass('is-active');
    }

    // クリック
    $tabs.on('click', function (e) {
        e.preventDefault();
        activateTab($(this), false);
    });

    // キーボード操作（← → ↑ ↓ / Home / End）
    $tabs.on('keydown', function (e) {
        var i = $tabs.index(this);
        var next;
        switch (e.which) {
        case 37: // ←
        case 38: // ↑
            next = (i - 1 + $tabs.length) % $tabs.length; break;
        case 39: // →
        case 40: // ↓
            next = (i + 1) % $tabs.length; break;
        case 36: // Home
            next = 0; break;
        case 35: // End
            next = $tabs.length - 1; break;
        default:
            return;
        }
        e.preventDefault();
        activateTab($tabs.eq(next), true);
    });

    // 初期化（念のため明示）
    $tabs.not(':first').attr({'aria-selected':'false','tabindex':'-1'});
    $panels.not(':first').attr('hidden', true);

    // ハッシュ連動（例: /page#panel-senior でそのタブを開く）
    var hash = window.location.hash.replace('#','');
    if (hash) {
        var $hashTab = $tabs.filter('[aria-controls="'+ hash +'"]');
        if ($hashTab.length) activateTab($hashTab, false);
    }

});
